import { connect, ConnectedProps } from 'react-redux';
import { Dispatch } from 'redux';
import {
  setFolders,
  setFoldersForDecisions,
} from '../../../../folders/state/actions';
import { StateType } from '../../../../state/state.types';

const mapState = ({ results, search, router: { location } }: StateType) => ({
  isSearchLoading: results.searchLoading,
  enableSnippets: search.enableSnippets,
  pathname: location.pathname,
  // @ts-expect-error: see https://doctrinelegal.atlassian.net/browse/INS-1865
  modalParam: location.query.modal,
});

const mapDispatch = (dispatch: Dispatch) => ({
  updateDecisionsFolders(decisionsFolders: {
    [string: string]: Array<string>;
  }) {
    dispatch(setFoldersForDecisions(decisionsFolders));
  },
  updateFolders(
    folders: {
      folderKey: string;
      title: string;
    }[],
  ) {
    dispatch(setFolders(folders));
  },
});

export const Connect = connect(mapState, mapDispatch);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
